import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowRight } from "lucide-react";

// Minimalist P logo SVG
const PlenaBPMNLogo = () => (
  <svg width="48" height="48" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 sm:w-12 sm:h-12">
    <path d="M20 20 Q20 10, 30 10 L50 10 Q70 10, 70 30 Q70 50, 50 50 L30 50 L30 90" 
          stroke="currentColor" 
          strokeWidth="8" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          fill="none"/>
    <circle cx="20" cy="20" r="8" fill="currentColor"/>
    <circle cx="20" cy="50" r="8" fill="currentColor"/>
    <circle cx="70" cy="30" r="8" fill="currentColor"/>
  </svg>
);

export default function Login() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
          credentials: 'include'
        });
        if (response.ok) {
          navigate("/dashboard");
        }
      } catch (error) {
        // Not authenticated
      }
    };
    checkAuth();
  }, [navigate]);

  const handleGoogleLogin = () => {
    window.location.href = `${process.env.REACT_APP_BACKEND_URL}/api/auth/google`;
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4 sm:p-6">
      <div className="w-full max-w-md">
        {/* Logo & Title */}
        <div className="text-center mb-8 sm:mb-12">
          <div className="inline-flex items-center justify-center mb-4 sm:mb-6">
            <PlenaBPMNLogo />
          </div>
          <h1 className="text-3xl sm:text-4xl font-semibold text-slate-900 mb-2 tracking-tight">
            PlenaBPMN
          </h1>
          <p className="text-slate-600 text-xs sm:text-sm px-4">
            Multi-Agent Business Process Analysis
          </p>
        </div>

        {/* Login Card */}
        <div className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 shadow-sm">
          <h2 className="text-lg sm:text-xl font-medium text-slate-900 mb-4 sm:mb-6 text-center">
            Hoş Geldiniz
          </h2>
          
          <Button
            onClick={handleGoogleLogin}
            className="w-full h-11 sm:h-12 bg-slate-900 hover:bg-slate-800 text-white rounded-xl font-medium transition-all duration-200 text-sm sm:text-base"
            size="lg"
          >
            <svg className="w-4 h-4 sm:w-5 sm:h-5 mr-2 sm:mr-3" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="currentColor"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="currentColor"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="currentColor"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            Google ile Giriş Yap
          </Button>

          <p className="text-[10px] sm:text-xs text-center text-slate-500 mt-4 sm:mt-6 leading-relaxed px-2">
            Giriş yaparak{" "}
            <a href="#" className="text-slate-900 hover:underline font-medium">Kullanım Koşulları</a>
            {" "}ve{" "}
            <a href="#" className="text-slate-900 hover:underline font-medium">Gizlilik Politikası</a>
            'nı kabul etmiş olursunuz.
          </p>
        </div>

        {/* Features - Mobile Optimized */}
        <div className="mt-6 sm:mt-10 flex items-center justify-center gap-4 sm:gap-8 text-center text-xs sm:text-sm text-slate-600">
          <div className="flex items-center gap-1.5 sm:gap-2">
            <span className="font-semibold text-slate-900 text-sm sm:text-base">8</span>
            <span className="hidden xs:inline">AI Agents</span>
            <span className="xs:hidden">Agents</span>
          </div>
          <div className="w-px h-3 sm:h-4 bg-slate-300"></div>
          <div className="flex items-center gap-1.5 sm:gap-2">
            <span className="font-semibold text-slate-900 text-sm sm:text-base">14</span>
            <span>Sections</span>
          </div>
          <div className="w-px h-3 sm:h-4 bg-slate-300"></div>
          <div className="flex items-center gap-1.5 sm:gap-2">
            <span className="font-semibold text-slate-900 text-sm sm:text-base">∞</span>
            <span className="hidden xs:inline">Possibilities</span>
            <span className="xs:hidden">Ideas</span>
          </div>
        </div>
      </div>
    </div>
  );
}
